import { Link } from "react-router-dom";
import { FiPhoneCall } from "react-icons/fi";
import { FaWhatsapp } from "react-icons/fa";
import "./FinalCTA.css";

export default function FinalCTA() {
  return (
    <section className="final-cta">
      <span className="final-cta__ghost" aria-hidden="true">FIRM FIT FACTORY</span>
      <div className="container final-cta__content">
        <h2>Your Strongest Version <span>Starts Here.</span></h2>
        <div className="final-cta__actions">
          <Link to="/contact" className="btn btn-primary">Join Now</Link>
          <a href="tel:+919500886368" className="btn btn-outline">
            <FiPhoneCall className="btn-icon" aria-hidden="true" /> Call Gym
          </a>
          <a href="https://wa.me/919500886368" className="btn btn-outline" target="_blank" rel="noopener noreferrer">
            <FaWhatsapp className="btn-icon" aria-hidden="true" /> WhatsApp Enquiry
          </a>
        </div>
        <p className="final-cta__address">
          Maheshwari Nagar, Vilangurichi Road, 4th Street, Peelamedu, Coimbatore – 641004, Tamil Nadu
        </p>
      </div>
    </section>
  );
}
